import { render, staticRenderFns } from "./OnlineStoresDisConnectedTab.vue?vue&type=template&id=8aed9e0c"
import script from "./OnlineStoresDisConnectedTab.vue?vue&type=script&lang=js"
export * from "./OnlineStoresDisConnectedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports